import { render, staticRenderFns } from "./PluginPartExport.vue?vue&type=template&id=2c04c5f6&scoped=true&"
import script from "./PluginPartExport.vue?vue&type=script&lang=js&"
export * from "./PluginPartExport.vue?vue&type=script&lang=js&"
import style0 from "./PluginPartExport.vue?vue&type=style&index=0&id=2c04c5f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c04c5f6",
  null
  
)

export default component.exports